<script setup lang="ts">
import UserAvatar from "@/components/ui/UserAvatar/UserAvatar.vue";
import type { AuthUser } from "@/model/user";

defineProps<{ assignees: AuthUser[] }>();
</script>

<template>
  <div>{{ $t("general.assignees") }}</div>
  <div v-for="assignee in assignees" :key="assignee.id" class="shortcut">
    <UserAvatar :user="assignee" size="small" />
    {{ assignee.name }}
  </div>
</template>

<style lang="scss" scoped>
.shortcut {
  margin-top: 0.2em;
  display: flex;
  gap: 0.5em;
}
</style>
